module.exports = __webpack_public_path__ + "img/header.3fd242d2.svg";